import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutUsPage = lazy(() => import('../pages/about-us/page'));
const LocationsPage = lazy(() => import('../pages/locations/page'));
const CustomSuitsPage = lazy(() => import('../pages/custom-suits/page'));
const CustomShirtsPage = lazy(() => import('../pages/custom-shirts/page'));
const CustomBlazersPage = lazy(() => import('../pages/custom-blazers/page'));
const AlterationsPage = lazy(() => import('../pages/alterations/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/about-us', element: <AboutUsPage /> },
  { path: '/locations', element: <LocationsPage /> },
  { path: '/custom-suits', element: <CustomSuitsPage /> },
  { path: '/custom-shirts', element: <CustomShirtsPage /> },
  { path: '/custom-blazers', element: <CustomBlazersPage /> },
  { path: '/alterations', element: <AlterationsPage /> },
  { path: '/service-areas', element: <ServiceAreasPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
